import { createSlice } from '@reduxjs/toolkit';
import { validateModel, validateFormField } from '../validation/marketingPreferences';
import { canProceed } from '../utils/validation/canProceed';

const initialState = {
  validation: {},
  hasTriedToSave: false,
  isDirty: false,
  isSaving: false,
  isLoading: false,
  canContinue: false,
  model: {
    post: '',
    voice: '',
    email: '',
    messaging: '',
    internet_banking: ''
  }
};

const marketingPreferences = createSlice({
  name: 'marketingPreferences',
  initialState,
  reducers: {
    loadMarketingPreferences: (state) => {
      state.isLoading = true;
    },
    loadMarketingPreferencesCompleted: (state, action) => {
      state.model = action.payload;
      state.isLoading = false;
    },
    loadMarketingPreferencesRejected: (state) => {
      state.isLoading = false;
    },
    modelChange: (state, action) => {
      state.model = action.payload;
      state.isDirty = true;
    },
    fieldChange: (state, { payload: { field, value, section } }) => {
      if (section) {
        state.model[section][field] = value;
      } else {
        state.model[field] = value;
      }
      state.isDirty = true;
    },
    validate: (state, action) => {
      state.validation = validateModel(action.payload);
      state.canContinue = canProceed(state.validation);
    },
    validateField: (state, action) => {
      const { field, value } = action.payload;

      state.validation[field] = validateFormField(field, value);
      state.canContinue = canProceed(state.validation);
    },
    resetValidation: (state) => {
      state.validation = initialState.validation;
      state.canContinue = false;
    },
    save: (state) => {
      state.isSaving = true;
      state.hasTriedToSave = true;
    },
    saveCompleted: (state) => {
      state.isSaving = false;
    },
    saveCancelled: (state) => {
      state.isSaving = false;
    },
    saveRejected: (state) => {
      state.isSaving = false;
    },
    resetState: () => initialState
  }
});

export function tryToContinue(model, callback) {
  return (dispatch) => {
    dispatch(validate(model));
    dispatch(checkCanContinue(callback));
  };
}

function checkCanContinue(callback) {
  return (dispatch, getState) => {
    const { canContinue } = getState().marketingPreferences;
    if (canContinue) {
      if (typeof callback === 'function') {
        callback();
      }
      dispatch(resetValidation());
    }
  };
}

export { marketingPreferences };
export const {
  fieldChange,
  loadMarketingPreferences,
  loadMarketingPreferencesCompleted,
  loadMarketingPreferencesRejected,
  modelChange,
  resetValidation,
  save,
  saveCancelled,
  saveCompleted,
  saveRejected,
  validate,
  validateField,
  resetState
} = marketingPreferences.actions;
